import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import YupValidations from '../../classes/yup-validations';
import { string } from 'yup';
import { TrackedAsyncData } from 'ember-async-data';
import { uniqueId } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import { on } from '@ember/modifier';
import focus from '../../modifiers/focus';
import pick from '../../helpers/pick';
import set from 'ember-set-helper/helpers/set';
import perform from 'ember-concurrency/helpers/perform';
import YupValidationMessage from '../yup-validation-message';
import LoadingSpinner from '../loading-spinner';

export default class SchoolNewVocabularyFormComponent extends Component {
  @service intl;
  @tracked title;

  validations = new YupValidations(this, {
    title: string()
      .required()
      .max(200)
      .test(
        'is-title-unique',
        (d) => {
          return {
            path: d.path,
            messageKey: 'errors.exclusion',
          };
        },
        (value) => value == null || !this.existingTitles.includes(value),
      ),
  });

  @cached
  get schoolVocabulariesData() {
    return new TrackedAsyncData(this.args.school.vocabularies);
  }

  get existingTitles() {
    if (!this.schoolVocabulariesData.isResolved) {
      return [];
    }
    return this.schoolVocabulariesData.value.map(({ title }) => title);
  }

  save = task({ drop: true }, async () => {
    this.validations.addErrorDisplayForAllFields();
    const isValid = await this.validations.isValid();
    if (!isValid) {
      return false;
    }
    await this.args.save(this.title, this.args.school, true);
    this.validations.clearErrorDisplay();
  });

  saveOrCancel = task({ drop: true }, async (event) => {
    const keyCode = event.keyCode;
    if (13 === keyCode) {
      await this.save.perform();
      return;
    }
    if (27 === keyCode) {
      this.args.close();
    }
  });
  <template>
    {{#let (uniqueId) as |templateId|}}
      <div class="school-new-vocabulary-form" data-test-school-new-vocabulary-form ...attributes>
        <div class="title">
          <h3>{{t "general.newVocabulary"}}</h3>
        </div>
        <div class="form">
          <div class="item" data-test-title>
            <label for="title-{{templateId}}">
              {{t "general.title"}}:
            </label>
            <input
              id="title-{{templateId}}"
              type="text"
              value={{this.title}}
              placeholder={{t "general.vocabularyPlaceholder"}}
              {{focus}}
              {{on "input" (pick "target.value" (set this "title"))}}
              {{on "keyup" (perform this.saveOrCancel)}}
              {{this.validations.attach "title"}}
            />
            <YupValidationMessage
              @description={{t "general.vocabulary"}}
              @validationErrors={{this.validations.errors.title}}
              data-test-title-validation-error-message
            />
          </div>
          <div class="buttons">
            <button
              type="button"
              class="done text"
              data-test-submit
              {{on "click" (perform this.save)}}
            >
              {{#if this.save.isRunning}}
                <LoadingSpinner />
              {{else}}
                {{t "general.done"}}
              {{/if}}
            </button>
            <button type="button" class="cancel text" {{on "click" @close}} data-test-cancel>
              {{t "general.cancel"}}
            </button>
          </div>
        </div>
      </div>
    {{/let}}
  </template>
}
